import type { ReactNode } from "react";

type EmptyStateProps = {
  eyebrow?: string;
  title: string;
  children?: ReactNode;
  action?: ReactNode;
};

export function EmptyState({ action, children, eyebrow, title }: EmptyStateProps) {
  return (
    <div className="rounded-lg border border-line bg-field p-8 shadow-soft">
      {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
      <h1 className="mt-3 text-3xl font-semibold tracking-normal text-ink">
        {title}
      </h1>
      {children ? (
        <div className="mt-4 max-w-2xl text-base leading-7 text-graphite/75">
          {children}
        </div>
      ) : null}
      {action ? <div className="mt-6">{action}</div> : null}
    </div>
  );
}
